import React from "react";
import { useStaticData } from "../../../hooks/useStaticData";
import { type MultiSelectProps, MultiSelectWithFilters } from "../MultiSelect";

// TODO - TEST STATIC
const BreedsMulti: React.FC<MultiSelectProps> = ({ ...props }) => {
	const { dogBreedNames: breeds } = useStaticData(["dogBreedNames"]);
	return (
		<MultiSelectWithFilters
			key={breeds.length}
			{...props}
			nonSchemaOptions={
				breeds
					?.map((breed) => ({ title: breed }))
					.filter(
						(name) =>
							![
								"Pit Bull Terrier",
								"Japanese Tosa",
								"Dogo Argentino",
								"Fila Brasileiro",
							].includes(name.title.trim()),
					) || []
			}
			value={[]}
		/>
	);
};

export default BreedsMulti;
